<template>
  <div>
    <div id="diagnoseauswahl-outer">
      Ihre Epilepsiediagnose:
      <b-form-select :options="listOfAllPossibleDiagnoses"
                     :value="bestaetigteDiagnose"
                     :state="bestaetigteDiagnoseSelected"
                     @input="updateBestaetigteDiagnose">
        <template #first>
          <b-form-select-option :value="'not set yet'" disabled>-- Bitte wählen Sie Ihre Epilepsiediagnose aus. Sie
            können der vorgeschlagenen
            Diagnose folgen oder eine andere Epilepsiediagnose stellen. --
          </b-form-select-option>
        </template>
      </b-form-select>
      <div v-if="patientIsWoman" style="margin-top: 40px;">
        Weiblicher Patient: Kann eine Konzeption bzw. Schwangerschaft ausgeschlossen werden?
        <b-form-radio-group :value="patientIsPregnant"
                            :options="radioPregnantOptions"
                            :checked="patientIsPregnant"
                            value-field="item"
                            text-field="name"
                            stacked
                            style="font-size: 15pt; margin-top: 20px"
                            :state="patientIsPregnantSelected"
                            required
                            @change="updatePatientIsPregnant">
          <b-form-invalid-feedback :state="patientIsPregnantSelected">Bitte wählen Sie eine Option aus
          </b-form-invalid-feedback>
        </b-form-radio-group>
      </div>


    </div>
  </div>
</template>

<script>
import diagnoseAlgorithm from "../../../js/clinical-algorithm/diagnose/diagnoseAlgorithm";
import {mapGetters, mapState} from "vuex";
import readRuleSetForDiagnose from "../../../js/clinical-algorithm/diagnose/readRuleSetForDiagnose";
import diagnoseConfiguration from "../../../js/clinical-algorithm/diagnose/Stage3_Diagnostik.csv";
import {calculateAge} from "../../../js/util";

export default {
  name: "DiagnoseAuswahl",
  computed: {
    ...mapGetters('cdss/diagnosestellung', [
      'vorgeschlageneDiagnose',
      'bestaetigteDiagnose',
      'patientIsPregnant',
      'bestaetigteDiagnoseSelected',
      'patientIsPregnantSelected',
    ]),
    ...mapState('cdss', {
      patientIsWoman: state => {
        const patientAge = calculateAge(state.patient.birthDate) >= 60;
        return state.patient.sex === 'w' && !patientAge;
      }
    }),
    listOfAllPossibleDiagnoses() {
      const alternativeDiagnoses = diagnoseAlgorithm.listOfAllPossibleDiagnoses(readRuleSetForDiagnose(diagnoseConfiguration))
          .filter(item => this.vorgeschlageneDiagnose === undefined || item !== this.vorgeschlageneDiagnose["DIAGNOSE"])
          .sort()
      if (this.vorgeschlageneDiagnose) {
        return [
          {
            label: "Vorgeschlagene Diagnose",
            options: [this.vorgeschlageneDiagnose["DIAGNOSE"]]
          },
          {
            label: "Alternative Diagnosen",
            options: alternativeDiagnoses
          }
        ]
      } else {
        return [
          {
            label: "Alternative Diagnosen",
            options: alternativeDiagnoses
          }
        ]
      }
    }
  },
  data() {
    return {
      radioPregnantOptions: [
        {item: 'j', name: 'Nein, Konzeption bzw. Schwangerschaft kann nicht ausgeschlossen werden'},
        {item: 'n', name: 'Ja, Konzeption bzw. Schwangerschaft kann ausgeschlossen werden'}
      ]
    }
  },
  methods: {
    updateBestaetigteDiagnose(e) {
      if (e !== this.bestaetigteDiagnose) {
        this.$store.commit("cdss/diagnosestellung/setBestaetigteDiagnose", e)
      }
      if (this.bestaetigteDiagnose !== 'not set yet' && this.bestaetigteDiagnoseSelected === false) {
        this.$store.commit("cdss/diagnosestellung/setBestaetigteDiagnoseSelected", null)
      }
    },
    updatePatientIsPregnant(e) {
      if (e !== this.patientIsPregnant) {
        this.$store.commit("cdss/diagnosestellung/setPatientIsPregnant", e)
      }
      if (this.patientIsPregnant !== 'irrelevant' && this.patientIsPregnantSelected === false) {
        this.$store.commit("cdss/diagnosestellung/setPatientIsPregnantSelected", null)
      }
    }
  }
}
</script>

<style scoped>
#diagnoseauswahl-outer {
  margin: 20px;
  font-size: 20pt;
}
</style>
